import moment from 'moment-timezone';
let dateFormat = 'YYYY-MM-DD HH:mm:ss';

export default function getDiffDate(timestamp) {
  let oldStamp = moment(timestamp).format(dateFormat);
  let currentStamp = moment(new Date()).format(dateFormat);
  let difference = moment(currentStamp).diff(oldStamp, 'minutes');
  return difference;
}